import { createFileRoute } from '@tanstack/react-router';
import { DirectoryPage } from '../../features/directory';

export const Route = createFileRoute('/portal/directory/')({ component: DirectoryPage });
